module.exports = __webpack_public_path__ + "static/lucaswork1-5d4b7c0501172b249f9585146df3f32a.jpg";